/*
* config.js
*
* Description: config.js
*
* This file is part of: "http://apps.sundair.com/", "SunCrew - Vacations"
* Copyright 2018,2019,2020, 2021, 2022  Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Christian Arp <christian.arp@sundair.com>
* @author Learek <michael.broeker@sundair.com>
*
*/
/******************************************************************************* 'ENV/CLIENT'
* Config: 'CONF_CLIENT'
*
* Note: 'Sundair', 'Flyair41'
*
*/
export const CONF_ENVIRONMENT = 'PROD'; // "DEV", "PROD"
export const CONF_CLIENT = 'Flyair41'; // 'Sundair', 'Flyair41'




/*******************************************************************************
* Config: CONF_CLIENT_LOGO'
*
* Note:
*
*/
export const CONF_CLIENT_LOGO = CONF_CLIENT === 'Sundair' ? 'https://sundair.com/res/images/logo.png' : 'https://directbooking.flyair41.de/res/images/sdr140x30.png';


/*******************************************************************************
* Config: 'CONF_CALENDAR_DAYS_RANGE - Calendar Date Range between from & to'
*
* Note: 'CALENDAR'
*/
export const CONF_CALENDAR_DAYS_RANGE = 31;


/*******************************************************************************
* Config: 'Standard Scheduler Time Range in Days'
*
*/
export const CONF_SCHEDULER_TIME_RANGE_DAYS = 31;


/*******************************************************************************
* Config: CONF_CLIENT_URL'
*
* Note:
*
*/
export const CONF_CLIENT_URL = CONF_CLIENT === 'Sundair' ? 'https://www.sundair.com' : 'https://www.flyair41.com';
export const CONF_CLIENT_URL_WRITTEN = CONF_CLIENT === 'Sundair' ? 'www.sundair.com' : 'www.flyair41.com';

export const CONF_CLIENT_URL_APPS = CONF_CLIENT === 'Sundair' ? 'https://apps.sundair.com' : 'https://www.flyair41.com';
export const CONF_CLIENT_URL_APPS_WRITTEN = CONF_CLIENT === 'Sundair' ? 'apps.sundair.com' : 'apps.flyair41.com';


/*******************************************************************************
* Config: CONF_CLIENT_URLS' - SC'
*
*
*
*/
export const CONF_CLIENT_URLS_SC2_FLIGHTS_PROD = CONF_CLIENT === 'Sundair' ? 'http://suncrew-flights.sundair.com/m' : 'http://suncrew-flights.flyair41.com/';
export const CONF_CLIENT_URLS_SC2_FLIGHTS_TEST = CONF_CLIENT === 'Sundair' ? 'http://test-suncrew-flights.sundair.com/' : 'http://test-suncrew-flights.flyair41.com/';

export const CONF_CLIENT_URLS_SC2_CALENDAR_PROD = CONF_CLIENT === 'Sundair' ? 'https://suncrew-calendar.sundair.com' : 'https://suncrew-calendar.flyair41.com';
export const CONF_CLIENT_URLS_SC2_CALENDAR_TEST = CONF_CLIENT === 'Sundair' ? 'http://test-suncrew-calendar.sundair.com' : 'http://test-suncrew-calendar.flyair41.com';

export const CONF_CLIENT_URLS_SC2_PEOPLE_PROD = CONF_CLIENT === 'Sundair' ? 'https://suncrew-people.sundair.com' : 'https://suncrew-people.flyair41.com';
export const CONF_CLIENT_URLS_SC2_PEOPLE_TEST = CONF_CLIENT === 'Sundair' ? 'http://test-suncrew-people.sundair.com' : 'http://test-suncrew-people.flyair41.com';

export const CONF_CLIENT_URLS_SC2_HOTELS_PROD = CONF_CLIENT === 'Sundair' ? 'https://suncrew-hotels.sundair.com' : 'https://suncrew-hotels.flyair41.com';
export const CONF_CLIENT_URLS_SC2_HOTELS_TEST = CONF_CLIENT === 'Sundair' ? 'http://test-suncrew-hotels.sundair.com' : 'http://test-suncrew-hotels.flyair41.com';

export const CONF_CLIENT_URLS_SC2_VACATION_PROD = CONF_CLIENT === 'Sundair' ? 'https://suncrew-vacations.sundair.com' : 'https://suncrew-vacations.flyair41.com';
export const CONF_CLIENT_URLS_SC2_VACATION_TEST = CONF_CLIENT === 'Sundair' ? 'http://test-suncrew-vacations.sundair.com' : 'http://test-suncrew-vacations.flyair41.com';

export const CONF_CLIENT_URLS_SC2_REPORTS_PROD = CONF_CLIENT === 'Sundair' ? 'https://suncrew-reports.sundair.com' : 'https://suncrew-reports.flyair41.com';
export const CONF_CLIENT_URLS_SC2_REPORTS_TEST = CONF_CLIENT === 'Sundair' ? 'http://test-suncrew-reports.sundair.com' : 'http://test-suncrew-reports.flyair41.com';

export const CONF_CLIENT_URLS_SC2_TIMESTATS_PROD = CONF_CLIENT === 'Sundair' ? 'https://suncrew-timestats.sundair.com' : 'https://suncrew-timestats.flyair41.com';
export const CONF_CLIENT_URLS_SC2_TIMESTATS_TEST = CONF_CLIENT === 'Sundair' ? 'http://test-suncrew-timestats.sundair.com' : 'http://test-suncrew-timestats.flyair41.com';

export const CONF_CLIENT_URLS_SC2_AIRPORTQUALIFICATIONS_PROD = CONF_CLIENT === 'Sundair' ? 'https://suncrew-airportqualifications.sundair.com' : 'https://suncrew-airportqualifications.flyair41.com';
export const CONF_CLIENT_URLS_SC2_AIRPORTQUALIFICATIONS_TEST = CONF_CLIENT === 'Sundair' ? 'http://test-suncrew-airportqualifications.sundair.com' : 'http://test-suncrew-airportqualifications.flyair41.com';

export const CONF_CLIENT_URLS_SC2_CONFIRMATIONOVERVIEW_PROD = CONF_CLIENT === 'Sundair' ? 'https://suncrew-confirmationoverview.sundair.com' : 'https://suncrew-confirmationoverview.flyair41.com';
export const CONF_CLIENT_URLS_SC2_CONFIRMATIONOVERVIEW_TEST = CONF_CLIENT === 'Sundair' ? 'http://test-suncrew-confirmationoverview.sundair.com' : 'http://test-suncrew-confirmationoverview.flyair41.com';

export const CONF_CLIENT_URLS_SC2_TRAININGS_PROD = CONF_CLIENT === 'Sundair' ? 'https://suncrew-trainings.sundair.com' : 'https://suncrew-trainings.flyair41.com';
export const CONF_CLIENT_URLS_SC2_TRAININGS_TEST = CONF_CLIENT === 'Sundair' ? 'http://test-suncrew-trainings.sundair.com' : 'http://test-suncrew-trainings.flyair41.com';

export const CONF_CLIENT_URLS_SC2_DUTYPLAN_PROD = CONF_CLIENT === 'Sundair' ? 'https://suncrew-dutyplan.sundair.com' : 'https://suncrew-dutyplan.flyair41.com';
export const CONF_CLIENT_URLS_SC2_DUTYPLAN_TEST = CONF_CLIENT === 'Sundair' ? 'http://test-suncrew-dutyplan.sundair.com' : 'http://test-suncrew-dutyplan.flyair41.com';





/*******************************************************************************
* Config: 'Allowed - GRANT'
*
*/
export const CONF_NEEDED_PERMISSION = 'sc2.vacations.admin';


/*******************************************************************************
* Config: 'Closing Day of Month for: "not longer editable"'
*
*/
export const CONF_CLOSING_DAY_OF_MONTH = CONF_CLIENT === 'Sundair' ? [10, 10, 10, 10, 8, 7, 8, 8, 9, 8, 8, 8] : [10, 10, 10, 10, 8, 7, 8, 8, 9, 8, 8, 8];


/*******************************************************************************
* Config: 'VERSION/REVISION NUMBER'
*
*/
export const CONF_VERSION_NUMBER = 'v2.0';
export const CONF_REVISIONS_NUMBER = 'r.137/9';
